import React, {createContext, HTMLAttributes, useContext} from "react";
import cfg, {Texts} from "../../config/general-config";
import {XAvailData} from "../../types/gen-types";

// get current page language as set by WordPress
// WordPress returns lang as 'en-US' or 'fr-CA', so need to extract lang code
const lang = document.documentElement.lang.substring(0,2)
const texts: Texts = lang == "en" ? cfg.texts.en : cfg.texts.fr

export const XWpContext = createContext<XWpContextData>({
    data: {
        wpMediaUrl: "",
        highRanges: [],
        highDays: [],
        idStilts: 0,
        idCabanitas: 0,
        idKaboum: 0
    },
    texts: texts
})
export const useWpContext = () => useContext(XWpContext)

type XWpContextData = {
    data: XAvailData
    texts: Texts
}

/**
 *
 * @param props
 * @constructor
 */
interface XProps extends HTMLAttributes<any> {
    xdata: XAvailData
}
const XWpProvider = (props: XProps) => {
    return (
        <XWpContext.Provider
            value={{
                data: props.xdata,
                texts
            }}
        >
            {props.children}
        </XWpContext.Provider>
    )
}
export default XWpProvider